module.exports = __webpack_public_path__ + "static/media/upb_logo.460ed104.png";